module.exports = __webpack_public_path__ + "static/media/news-kevin-martin-02.cb001356.jpg";